// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"e90da4e9","37":"84987ba3","55":"64479dbe","171":"9226ab8a","429":"329d66e2"}[chunkId] + ".chunk.js";
};